export class ListUsersError extends Error {}
